module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "id": "scroll-0",
      "fluid": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.loading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7,
      "color": "primary"
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.notFound) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "id": "md-container"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.markdown)
    }
  }) : _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', [_vm._v("Repositorio sin README =(")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.onScroll),
      expression: "onScroll"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.fab),
      expression: "fab"
    }],
    attrs: {
      "color": "primary",
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    },
    on: {
      "click": _vm.toTop
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_up")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b66a161","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MarkdownView.vue
// module id = 263
// module chunks = 1